export interface AiChatPreferences {
  areActionTilesHidden: boolean;
  generateAudio: boolean;
}

export const DEFAULT_PREFERENCES: AiChatPreferences = {
  areActionTilesHidden: true,
  generateAudio: true,
};

export const getAiChatPreferences = async (): Promise<AiChatPreferences> => {
  try {
    const raw = (await window.PMW.readLocal('ai/getAiChatPreferences')) as Partial<AiChatPreferences> | null;
    return {
      areActionTilesHidden: raw?.areActionTilesHidden ?? DEFAULT_PREFERENCES.areActionTilesHidden,
      generateAudio: raw?.generateAudio ?? DEFAULT_PREFERENCES.generateAudio,
    };
  } catch (error) {
    console.error(error);
    return DEFAULT_PREFERENCES;
  }
};

export const hideActionTiles = async (): Promise<void> => {
  await window.PMW.writeLocal('ai/hideActionTiles', {});
};

export const setAiChatGenerateAudio = async (generateAudio: boolean): Promise<void> => {
  await window.PMW.writeLocal('ai/setAiChatGenerateAudio', {generateAudio});
};

export const markAiChatTemplatesTileAsSeen = async (): Promise<void> => {
  await window.PMW.writeLocal('ai/markAiChatTemplatesTileAsSeen', {});
};

export const hasUserSeenAiChatTemplatesTile = async (): Promise<boolean> => {
  try {
    return Boolean(await window.PMW.readLocal('ai/hasUserSeenAiChatTemplatesTile'));
  } catch (error) {
    console.error(error);
    return false;
  }
};
